import { render, staticRenderFns } from "./RoofSideShadow.vue?vue&type=template&id=2e88ec4c"
import script from "./RoofSideShadow.vue?vue&type=script&lang=js"
export * from "./RoofSideShadow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports